<template>
    <div>
        <router-link to="recibosesam"> <span class="glyphicon glyphicon-arrow-left"></span> volver atras </router-link>
        <h3 class="text-center" style="margin-top:0"> Recibos generados </h3>
        <p> 
            <input v-model.trim="filtro" class="inputs" type="text" placeholder="texto a buscar...">
            <input v-model.trim="busqueda.fecha_ini" class="inputs" type="date">
            <input v-model.trim="busqueda.fecha_fin" class="inputs" type="date"> 
            <button class="btn btn-sm btn-azul oulined" @click="listarrecibos(null,1)"> buscar </button>
            <button class="btn btn-sm btn-success oulined" @click="listarrecibos(true,1)"> ver todos </button>
            <button class="btn btn-sm btn-danger oulined" @click="listarrecibos(true,0)"> ver eliminados </button>
        </p>

        <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
        </div>
        <button :disabled="$store.state.isonlyread" v-show="recibos.length" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')"> <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL </button>
        <p class="text-center"> {{msg}} </p>

        <div v-show="recibos.length">
            <small> {{recibos.length}} recibos. </small>
            <table ref="table" class="table table-condensed">
                <thead>
                    <tr>
                        <th>Nro.</th>
                        <th>Estudiante</th>
                        <th>Monto</th>
                        <th v-show="false">Documento</th>
                        <th v-show="false">Telefono</th>
                        <th v-show="false">Celular</th>
                        <th>Asesor</th>
                        <th>Emisor</th>
                        <th>Lugar</th>
                        <th>Fecha</th>
                        <th>Fact.</th>
                        <th v-show="false">Concepto</th>
                        <th v-show="false">Forma de pago</th>
                        <th v-show="false">Saldo</th>
                        <th v-show="false">Cuota</th>
                        <th v-show="false">Direccion</th>
                        <th v-show="false">Zona</th>
                        <th v-show="false">Proximo pago</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(r,ind) in recibos" :key="ind">
                        <td> 00{{r.nro}} </td>
                        <td> {{r.estudiante}} </td>
                        <td> {{r.monto}} Bs. </td>
                        <td v-show="false"> {{r.num_doc}} </td>
                        <td v-show="false"> {{r.telefono}} </td>
                        <td v-show="false"> {{r.celular}} </td>
                        <td> {{r.asesor}} </td>
                        <td> {{r.emisor}} </td>
                        <td> {{r.lugar}} </td>
                        <td> {{parseFecha(r.fecha_pago)}} </td>
                        <td> {{r.nro_factura}} </td>
                        <td v-show="false"> {{r.concepto}} </td>
                        <td v-show="false"> {{r.forma_pago}} </td>
                        <td v-show="false"> {{parsesaldo(r.saldo)}} </td>
                        <td v-show="false"> {{r.num_cuota}} </td>
                        <td v-show="false"> {{r.direccion}} </td>
                        <td v-show="false"> {{r.zona}} </td>
                        <td v-show="false"> {{parseFecha(r.proximo_pago)}} </td>
                        <td>
                            <button class="btn btn-link btn-sm" @click="cargarfondo(r)" data-toggle="modal" data-target="#modal-recibo"> <span class="glyphicon glyphicon-eye-open"></span> </button>
                            <button :disabled="!$store.state.eliminarRecibo" class="btn btn-link btn-sm" @click="preanularrecibo(r)"> <span class="glyphicon glyphicon-remove"></span> </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div class="modal-body pt-0" id="content-preview">
            <div style="width:10px!important;height:10px!important;overflow:hidden">
                <canvas id="canvasrecibo" width="1280" height="1080"></canvas>
            </div>
        </div>


        <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-recibo">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center"> <b> Visualizacion </b> </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="center-block" style="width:100%;height:540px">
                        <canvas id="myCanvasview" style="border:1px solid #55d3d3d3;width:100%;height:100%"></canvas>
                    </div>
                    <div class="text-center">
                        <div style="display: inline-block;" v-show="loadingfondo" class="loader"></div>
                    </div>
                </div>
                
                <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-success" @click="guardarpdf()"> Descargar PDF </button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
                </div>
            </div>
        </div>
                    
    </div>
</template>



<script>
import gql from 'graphql-tag'
export default {
  data(){
    return{
        // EXCEL 
        uri :'data:application/vnd.ms-excel;base64,',
        template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
        format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
        // END EXCEL
        busqueda: { fecha_ini: null,fecha_fin: null, },
        recibos:[],
        loading: false,
        loadingfondo: false,
        filtro:null,
        fondo:null,
        msg:'',
        input:{
            lugar: '', 
            nro:'',
            monto: null,
            estudiante: '',
            num_doc: '', 
            telefono: '', 
            celular: '', 
            concepto: '', 
            forma_pago: '', 
            saldo: null,
            num_cuota: '', 
            direccion: '', 
            zona: '', 
            proximo_pago: '',
            asesor: '',
            emisor: '',
            recibo_fondo: '',
            sede_id: -1,
            fecha_pago: '',
            nro_factura: '',
        }
    }
  },
  components:{},
  validators: {
  },
  watch:{
      '$store.state.CARGO.idsede': function (a){ this.idsede = a; },
      'input':{
          deep: true,
          handler(){ this.cargardatos(); }
      }
  },
  methods:{
      tableToExcel(table, name){
        if (!table.nodeType) table = this.$refs.table
        var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
        var link = document.createElement("a");
        link.download = "reporte_recibos.xls";
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
    parseFecha(f){
        if( !f ) return '';
      var strs = f.split('T');
      var fs = strs[0].split('-');
      return fs[2]+'/'+fs[1]+'/'+fs[0];
    },
    parsesaldo( s ){
        if( !s ) return '';
        else return s+' Bs.';
    },
      cargarfondo( recibin ){
          this.input = recibin;
          var canvas = document.getElementById('canvasrecibo');
          var ctx = canvas.getContext('2d');
          const vue = this;
          this.loadingfondo = true;
          this.fondo = new Image();
          this.fondo.setAttribute('crossorigin', 'anonymous');

          window.console.log( 'EXISTE::',this.input.recibo_fondo )
          if( this.input.recibo_fondo.includes('img/') ){
              this.fondo.src = this.input.recibo_fondo;
          }else if( this.input.recibo_fondo.includes('firma-') ){
              this.fondo.src = process.env.VUE_APP_URL_BG_FIRMA_USER+this.input.recibo_fondo;
          }else{
              var iduser = this.$store.state.DATA_USER.id;
                var fondito = '';
                if (iduser == 31) fondito = 'img/recibo_andrea.png';
                else if (iduser == 74) fondito = 'img/recibo_celina.jpg';
                else if (iduser == 10730) fondito = 'img/recibo_grecia.png';
                else if (iduser == 8740) fondito = 'img/recibo_ecoca.png';
                else if (iduser == 11155) fondito = 'img/recibo_jtrigo.png';
                else if (iduser == 3522) fondito = 'img/recibo_pgarcia.png';
                else if (iduser == 1406) fondito = 'img/recibo_pmontoya.png';
                else if (iduser == 1405) fondito = 'img/recibo_mguevara.png';
                else if (iduser == 818) fondito = 'img/recibo_oarancibia.png';
                else if (iduser == 18) fondito = 'img/recibo_raquel.png';
                else if (iduser == 3145) fondito = 'img/recibo_afernandez.png';
                else if (iduser == 3506) fondito = 'img/recibo_mcarvajal.png';
                else if (iduser == 3522) fondito = 'img/recibo_pgarcia.png';
                else if (iduser == 11004) fondito = 'img/recibo_apacheco.png';
                else if (iduser == 11219) fondito = 'img/recibo_grodriguez.png';
                else if (iduser == 6476) fondito = 'img/recibo_lvasquez.png';
                else if (iduser == 870) fondito = 'img/recibo_nsoruco.png';//
                else fondito = 'img/recibodemo.jpg';
                //this.fondo.src = process.VUE_APP_URL_BG_RECIBO_SEDE+this.input.recibo_fondo;
                this.fondo.src = fondito;
          }
          this.fondo.addEventListener('load', function() {
              ctx.drawImage(vue.fondo, 0, 0,1280, 1080);
              vue.cargardatos();
              vue.loadingfondo = false;
            }, false);
      },
      cargardatos(){
        var canvas = document.getElementById('canvasrecibo');
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if( this.fondo ) ctx.drawImage(this.fondo, 0, 0,1280, 1080);
        if( !this.input.direccion ) this.input.direccion = '';
        if( !this.input.zona ) this.input.zona = '';
        if( !this.input.celular ) this.input.celular = '';
        if( !this.input.num_cuota ) this.input.num_cuota = '';
        if( !this.input.num_doc ) this.input.num_doc = '';

        const fp = this.parseFecha( this.input.fecha_pago );
        const fs = fp.split('/');
        const d = fs[0];
        const m = fs[1];
        const a = fs[2];
        var pp = '';
        //const dy = 140;

        if( this.input.proximo_pago ){
            pp = this.parseFecha( this.input.proximo_pago );
        }


        ctx.font = "27px Arial";
        ctx.textAlign = "center";
        ctx.fillText(""+this.input.lugar, (canvas.width/2)-490, 320+60);
        ctx.fillText(""+d, (canvas.width/2)-350, 320+60);
        ctx.fillText(""+m, (canvas.width/2)-275, 320+60);
        ctx.fillText(""+a, (canvas.width/2)-205, 320+60);

        ctx.font = "38px Arial";
        ctx.fillText("N° 000"+this.input.nro, (canvas.width/2), 340+70);

        ctx.font = "27px Arial";
        ctx.fillText(''+this.input.monto, (canvas.width/2)+400, 280+50);
        ctx.fillText('_____', (canvas.width/2)+410, 320+60);

        ctx.fillText(''+this.input.estudiante, (canvas.width/2)-40, 443+84);
        ctx.fillText(''+this.input.num_doc, (canvas.width/2)+410, 443+84);
        ctx.fillText(''+this.input.direccion, (canvas.width/2)-315, 506+95);
        ctx.fillText(''+this.input.zona, (canvas.width/2)-10, 506+95);
        if( this.input.nro_factura ){
            ctx.fillStyle = "#ffffff";
            ctx.fillText('____', (canvas.width/2)+389, 505+95);
            ctx.font = "bold 22px verdana, sans-serif";
            ctx.fillStyle = "#1A2D60";
            ctx.fillText('Fact.:', (canvas.width/2)+390, 509+95);
            ctx.font = "27px Arial";
            ctx.fillStyle = "#000000";
            ctx.fillText(''+this.input.nro_factura, (canvas.width/2)+490, 506+95);
            ctx.fillText(''+this.input.celular, (canvas.width/2)+235, 506+95);
        }else{
            ctx.fillText(''+this.input.celular, (canvas.width/2)+360, 506+95);
        }
        ctx.fillText(''+this.input.concepto, (canvas.width/2)+70, 557+107);
        ctx.fillText(''+this.input.forma_pago, (canvas.width/2)+60, 614+117);
        ctx.fillText(''+this.input.monto+' Bs.', (canvas.width/2)-430, 664+125);
        if( this.input.saldo ) ctx.fillText(''+this.input.saldo+' Bs.', (canvas.width/2)-130, 664+125);
        ctx.fillText(''+this.input.num_cuota, (canvas.width/2)+150, 664+125);
        ctx.fillText(''+pp, (canvas.width/2)+490, 664+125);
        ctx.fillText(''+this.input.asesor, (canvas.width/2)-250, 710+135);
        ctx.fillText(''+this.input.emisor, (canvas.width/2)+350, 710+135);

        this.previewCertificado( canvas );
    },
    previewCertificado( canvas ){
        var modalsize = document.getElementById("content-preview").getBoundingClientRect();
        var a = (((modalsize.width+140) * 100) / canvas.width)/100;
        var destinationCanvas = document.getElementById("myCanvasview");
        var destCtx = destinationCanvas.getContext('2d');
        destinationCanvas.width = canvas.width;
        destinationCanvas.height = canvas.height/2;
        destCtx.scale(a, 0.5);
        destCtx.drawImage(canvas, 0, 0);
    },
    guardarpdf(){
        var canvas = document.getElementById("canvasrecibo");
        let width = canvas.width; 
        let height = canvas.height;
        var pdf;
        var nombre = this.input.estudiante+'-000'+this.input.nro;

        if (width > height) { pdf = new window.jsPDF('l', 'px', [width, height]); } 
        else { pdf = new window.jsPDF('p', 'px', [height, width]); }

        width = pdf.internal.pageSize.getWidth();
        height = pdf.internal.pageSize.getHeight();
        pdf.addImage(canvas, 'JPG', 0, 0, width, height);
        pdf.save(nombre + '.pdf');
    },
    fechasdefault(){
        var date = new Date();
        var date2 = new Date();
        date.setDate( date.getDate()-7 )
        date2.setDate( date2.getDate()+1 )
        var d1 = date.getDate()
        var m1 = date.getMonth()+1
        var d2 = date2.getDate()
        var m2 = date2.getMonth()+1
        if( d1 < 10 ) d1 = '0'+d1;
        if( m1 < 10 ) m1 = '0'+m1;
        if( d2 < 10 ) d2 = '0'+d2;
        if( m2 < 10 ) m2 = '0'+m2;

        var f1 = date.getFullYear()+'-'+m1+'-'+d1;
        var f2 = date2.getFullYear()+'-'+m2+'-'+d2;

        this.busqueda.fecha_ini = f1;
        this.busqueda.fecha_fin = f2;
    },
    listarrecibos( todos,tipo ){
        if( this.filtro && this.filtro.length < 3 ) {
            this.msg = 'Ingrese un texto mas largo para buscar.';
            return;
        }
        if( !this.busqueda.fecha_ini || !this.busqueda.fecha_fin ){
             this.msg = 'Faltan parametros, Complete los campos de fechas';
            return;
        }
        this.recibos = [];
        this.loading = true;
        this.msg = '';
        this.idsede = this.$store.state.CARGO.idsede;
        const vue = this;
        var iduser = this.$store.state.DATA_USER.id;
        var idcargo = this.$store.state.CARGO.id;
        let txt = `sede_id:${this.idsede},fechas:${window.stringifyObject(this.busqueda)},tipo:${tipo}`;
        if( this.filtro && this.filtro.length > 3 ) txt += `,search_text:"${this.filtro}"`;
        if( !(todos || idcargo == 1) ) txt += `,usuario_id:${iduser}`;

        const sql = gql`query{ getRecibos(${txt})
        {id,codigo,nro,lugar,nro_factura,direccion,zona,num_doc,estudiante,telefono,celular,concepto,forma_pago,monto,saldo,num_cuota,fecha_pago,proximo_pago,fecha_registro,asesor,emisor,recibo_fondo,sede_id,usuario_id,estado,sede{nombre},usuario{nombres,pri_apellido}} }`;
        window.console.log( sql );

        this.$apollo.query({
            query: sql,
        }).then((data) => {
            var res = data.data.getRecibos;
            if( !res || res.length == 0 ){
                this.msg = 'Sin resultados';
            }else{
                res = res.sort( function(a,b){ return b.nro - a.nro } );
                this.recibos = res;
            }
            this.loading = false;
        }).catch((error) => {
            vue.loading = false;
            window.console.error(error);
            vue.msg = error;
        })
    },
    preanularrecibo( recibin ){
        const vue = this;
        var message = {
            title:'Confirme que desea proceder',
            body: '<br> <b>NOTA:</b> Esta accion es irreversible y no se podra recuperar el recibo eliminado, si esta de acuerdo puede proceder a eliminarlo.'
        };
        var options = {html:true,okText: 'Proceder',cancelText: 'Cancelar',reverse:true,type:'hard',
            verification: 'eliminar',verificationHelp: 'Escriba "[+:verification]" para proceder.',loader: true,};
            this.$dialog.confirm(message,options)
            .then(function(dialog) {
                vue.anularRecibo( recibin,dialog );
            }).catch(function() {});
    },
    anularRecibo( recibo,dialog ){
      var sql = gql`mutation{ eliminarRecibo(input:{id:${recibo.id}}){ok errors{message}} }`;
      this.$apollo.mutate({ mutation: sql,
      }).then((data) => {
        var datos = data.data.eliminarRecibo;
        if( datos.ok ){
          var rec = this.recibos.find( x => x.id == recibo.id );
          if( rec ) rec.nro = "ELIMINADO";
        }else{
          var errores = JSON.stringify(data.data.eliminarRecibo.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          this.msg = vals;
        }
        dialog.close();

      }).catch((error) => {
        this.msg = error;
        window.console.error(error)
      })
    },
  },
  mounted(){
      this.fechasdefault();
      this.listarrecibos( null,1 );
  }
}
</script>
